import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Manifesto } from "../components/landing/Sections";
import { History } from "../components/landing/Story";
import { Awards, Clients } from "../components/landing/Showcase";
import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { useLang } from "../context/LanguageContext";

export { PageHero };

export default function AboutPage() {
  const { t } = useLang();
  return (
    <div className="bg-[#FAF7F2] min-h-screen" data-testid="about-page">
      <Header />
      <PageHero overline={t("aboutsec.overline")} title={t("aboutsec.title")} testid="about-title" img="/assets/hero-2.jpg" />
      <section className="pb-10 px-6 sm:px-12">
        <div className="max-w-5xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <p className="text-[#1B2A4E]/70 leading-loose text-lg">{t("aboutsec.body")}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="rounded-[2rem] overflow-hidden border-4 border-white shadow-2xl shadow-[#1B2A4E]/20">
              <img src="/assets/hero-1.jpg" alt="Hire Host" loading="lazy" className="w-full h-80 object-cover" />
            </div>
          </Reveal>
        </div>
      </section>
      <Manifesto />
      <History />
      <Awards />
      <Clients />
      <Footer />
    </div>
  );
}
